import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class TransferProdDetailService extends DatabaseGwService{

  URL_PATH: string = "/transfer-prod-details";
}
